var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconMessage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.208 9.894a12 12 0 0 0-5.22-1.183 12 12 0 0 0-10.23 18.271l-1.715 4.57a.857.857 0 0 0 .956 1.145l5.988-1.089a12 12 0 0 0 10.22-21.714zm-5.22.531v-.857l.002.857a10.286 10.286 0 1 1-4.507 19.521.856.856 0 0 0-.53-.074l-4.775.868 1.335-3.556a.857.857 0 0 0-.089-.776 10.286 10.286 0 0 1 8.564-15.983zm-5.19 8.57a1.714 1.714 0 1 0 0 3.428 1.714 1.714 0 0 0 0-3.428zm5.144 0a1.714 1.714 0 1 0 0 3.428 1.714 1.714 0 0 0 0-3.428zm3.93.502a1.714 1.714 0 1 1 2.425 2.424 1.714 1.714 0 0 1-2.425-2.424z",
    fill: "#000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMessage);
export default __webpack_public_path__ + "static/media/icon-message.4d72e99b.svg";
export { ForwardRef as ReactComponent };